import { useEffect, useState } from 'react';
import { getCrmJobSettingsByWorkspaceId } from 'wisestep-api';

export const useCrmJobSettings = (workspaceId: string) => {
  const [reviewContactCount, setReviewContactCount] = useState(0);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        if (workspaceId) {
          const res = await getCrmJobSettingsByWorkspaceId(workspaceId);
          setReviewContactCount(res.data?.reviewContactCount || 0);
        }
      } catch (e) {
        console.error('Error loading CRM job settings:', e);
        setReviewContactCount(0);
      }
    };

    fetchSettings();
  }, [workspaceId]);

  return reviewContactCount;
};
